import React from 'react';
import { useFilterController } from '../../../../application/useFilterController';
import { timeOnMarketRentOptions, timeOnMarketBuyOptions, timeOnMarketSoldOptions } from '../../../../domain/filterOptions';
import { TimeOnMarketBody } from './TimeOnMarketBody';
import { ListingDetailsStatusBody } from './ListingDetailsStatusBody';
import { StatusFlag, Range } from '../../../../domain/FilterTypes';
import { parseTimeOnMarketValue } from '../../../../domain/mappers/timeOnMarketMapper';

export const ListingDetailsDrawerSection = () => {
  const { marketingStatus, timeOnMarketRange, setTimeOnMarketRange, filter, setFilterDirect } = useFilterController();

  // Derive sale/rent context from marketingStatus
  const saleOrRent = marketingStatus === 'FOR_RENT' ? 'for_rent'
    : marketingStatus === 'SOLD' ? 'sold'
      : 'for_sale';

  const timeOnMarketOptions = saleOrRent === 'for_sale'
    ? timeOnMarketBuyOptions
    : saleOrRent === 'for_rent'
      ? timeOnMarketRentOptions
      : timeOnMarketSoldOptions;

  const handleTimeOnMarketChange = (value: string) => {
    const newRange = parseTimeOnMarketValue(value, saleOrRent);
    setTimeOnMarketRange(newRange);
  };

  const handleStatusFlagsChange = (statusFlags: StatusFlag[]) => {
    setFilterDirect((prev) => ({
      ...prev,
      statusFlags
    }));
  };

  return (
    <div className="p-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <ListingDetailsStatusBody
          statusFlags={filter.statusFlags || []}
          onChange={handleStatusFlagsChange}
        />
        <TimeOnMarketBody
          options={timeOnMarketOptions}
          value={timeOnMarketRange || Range.create(null, null)}
          onChange={handleTimeOnMarketChange}
        />
      </div>
    </div>
  );
};
